import Gallery from 'components/molecules/gallery/Gallery';
import { useFormikContext } from 'formik';
import { IMerchMutationForm } from 'services/merch/types';

const MerchImages = () => {
  const { initialValues } = useFormikContext<IMerchMutationForm>();
  return (
    <Gallery<IMerchMutationForm> 
      showMainImageControls={true}
      isMainImg={initialValues.EAN.length > 0} 
    />
  );
};

export default MerchImages;
